var HistoryKey = /* @__PURE__ */ ((HistoryKey2) => {
  HistoryKey2["HISTORY_ITEM"] = "HISTORY_ITEM";
  HistoryKey2["HISTORY_ACCESS"] = "HISTORY_ACCESS";
  return HistoryKey2;
})(HistoryKey || {});
const createHistoryAccessFirstPart = () => ["HISTORY_ACCESS" /* HISTORY_ACCESS */];
const createHistoryAccessKey = (id) => ({
  first_part: createHistoryAccessFirstPart(),
  second_part: [id]
});
const createHistoryItemFirstPart = (historyId) => ["HISTORY_ITEM" /* HISTORY_ITEM */, historyId];
const createHistoryItemKey = ({
  historyId,
  timestamp,
  uniqueId,
  step,
  order
}) => ({
  first_part: createHistoryItemFirstPart(historyId),
  second_part: [Number.MAX_SAFE_INTEGER - timestamp, step, order, uniqueId]
});
export {
  HistoryKey,
  createHistoryAccessFirstPart,
  createHistoryAccessKey,
  createHistoryItemFirstPart,
  createHistoryItemKey
};
//# sourceMappingURL=keys.js.map